const locale = {
  placeholder: 'Válasszon időt',
};

export default locale;
